import React, { useState } from "react";
import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import {
  PolicyData,
  PolicyData_hindi,
  PolicyData_kannada,
} from "pages/individualPages/JSON/PolicyData";
import Policy from "./Policy";
import PolicyHeader from "./PolicyHeader";

function TermsAndCondition() {
  const searchParams = new URLSearchParams(window.location.search);
  const type = searchParams.get("type");
  const isMobileParams = searchParams.get("isMobile") === "true";
  const [selectedLanguage, setSelectedLanguage] = useState("English");

  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    setSelectedLanguage(newLanguage);
  };
  const Language = ["English", "Hindi", "Kannada"];
  return (
    <div>
      {type && isMobileParams ? (
        <div>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            className="marginHeader"
          >
            <Grid item className="marginRight10 marginTop">
              <FormControl fullWidth className="commonFormControl">
                <Select
                  value={selectedLanguage ? selectedLanguage : "English"}
                  onChange={handleLanguageChange}
                  inputProps={{ "aria-label": "Without label" }}
                >
                 <MenuItem disabled>
                   <em>Language</em>
                  </MenuItem>
                  {Language?.map((option, index) => (
                    <MenuItem key={index} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          {selectedLanguage && selectedLanguage === "Hindi" ? (
            <Policy policyData={PolicyData_hindi} />
          ) : selectedLanguage === "Kannada" ? (
            <Policy policyData={PolicyData_kannada} />
          ) : (
            <Policy policyData={PolicyData} />
          )}
        </div>
      ) : (
        <div>
          <PolicyHeader />
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="marginHeader"
          >
            <Grid item>
              <Typography className="policyHeading">Terms and Conditions</Typography>
            </Grid>
            <Grid item className="marginRight10">
              <FormControl fullWidth className="commonFormControl">
                <Select
                  value={selectedLanguage ? selectedLanguage : "English"}
                  onChange={handleLanguageChange}
                  inputProps={{ "aria-label": "Without label" }}
                >
                 <MenuItem disabled>
                   <em>Language</em>
                  </MenuItem>
                  {Language?.map((option, index) => (
                    <MenuItem key={index} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          {selectedLanguage && selectedLanguage === "Hindi" ? (
            <Policy policyData={PolicyData_hindi} />
          ) : selectedLanguage === "Kannada" ? (
            <Policy policyData={PolicyData_kannada} />
          ) : (
            <Policy policyData={PolicyData} />
          )}
        </div>
      )}
    </div>
  );
}

export default TermsAndCondition;
